import React from 'react'


class FooterContent extends React.Component {

	render() {
		return (
			<ul className="list-unstyled list-inline">
			  <li className="list-inline-item">
			    <a href="https://adbility-media.com/impressum">Impressum</a>
			  </li>
			  <li className="active list-inline-item">
			    <a href="https://adbility-media.com/kontakt">Kontakt</a>
			  </li>
			  <li className="list-inline-item">
			    <a href="https://adbility-media.com/agb">AGB</a>
			  </li>
			</ul>
		)
	}
}

export default FooterContent


// WEBPACK FOOTER //
// ./src/components/LayoutComponents/FooterContent/index.js